import React, { useState, useEffect, useContext } from 'react';
import { useHistory, useParams } from 'react-router-dom';
import { toast } from 'react-toastify';
import { useTranslation } from 'react-i18next';
import userService from '../../services/user.service';
import { AuthContext } from '../../contexts/AuthContext';
import { toastOptions } from '../shared/selectStyle';
import validateEmail from '../shared/validateEmail';

const Member = () => {
    const { t } = useTranslation();
    const params = useParams();
    const { user } = useContext(AuthContext);
    const history = useHistory();
    const [error, setError] = useState(false);
    const [invalidEmail, setInvalidEmail] = useState(false);
    const [invalidPassword, setInvalidPasword] = useState(false);
    const [member, setMember] = useState({
        firstName: '',
        lastName: '',
        password: '',
        email: ''
    });

    useEffect(() => {
        onRouteChanged();
    }, [params.memberId]);

    const getUserById = async (memberId) => {
        const response = await userService.getUserById(memberId);
        setMember(response)
    }

    const onRouteChanged = async () => {
        let memberId = params.memberId;
        await getUserById(memberId)
    }


    const handleChange = (event) => {
        setError(false);
        setInvalidEmail(false);
        setInvalidPasword(false);
        setError(false);
        const target = event.target;
        const value = target.type === 'checkbox' ? target.checked : target.value;
        const name = target.name;
        setMember({
            ...member,
            [name]: value.trim()
        });
    }

    const handleSubmit = async (event) => {
        event.preventDefault();
        if (validateForm()) {
            await userService.updateUserByCreator(member);
            toast.success("Member is successfully updated!", toastOptions);
            history.push("/dashboard/company/" + user._id);
        } 
    }

    const validateForm = () => {
        if (member.email) {
            if (!validateEmail(member.email)) {
                setInvalidEmail(true)
                return false
            }
        }
        let isValid = member.password && member.email && member.email && member.firstName && member.lastName;
        if (!isValid) {
            setError(true);
            return isValid;
        };
        if (member.password.length < 4) {
            setInvalidPasword(true);
            return false;
        }
        return isValid;
    }
    return (
        <div className="dashboard-view space-around">
            <h4 className="h4-title">{t('company.member.title')}</h4>
            <form className="form-sm" onSubmit={handleSubmit}>
                <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.firstname')}:</label>
                    <input id='firstname' className="form-control" type="text" name="firstName" value={member.firstName} onChange={handleChange} placeholder={t('placeholder.firstname')} />
                </div>
                <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.lastname')}:</label>
                    <input id='lastName' className="form-control" type="text" name="lastName" value={member.lastName} onChange={handleChange} placeholder={t('placeholder.lastname')} />
                </div>
                <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.email')}:</label>
                    <input type="email" className="form-control" name="email" value={member.email} onChange={handleChange} placeholder={t('placeholder.email')} />
                </div>
                <div className="form-group custom-input">
                    <label htmlFor=""> {t('placeholder.password')}:</label>
                    <input type="text" className="form-control" name="password" value={member.password} onChange={handleChange} placeholder={t('placeholder.password')} />
                </div>
                {error ? <div className="message-alert"><p>{t('requiredFields.msg')}</p></div> : null}
                {invalidEmail ? <div className="message-alert"><p>Please enter valid email address!</p></div> : null}
                {invalidPassword ? <div className="message-alert"><p>Password needs to be longer than 3 characters!</p></div> : null}

                <button className="btn btn-blue">{t('update')}</button>
            </form>
        </div>
    );
}

export default Member;



// WEBPACK FOOTER //
// ./src/components/companyComponent/member.js